import React, { useEffect, useRef, useState } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
} from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import { Trans, useTranslation } from "react-i18next";
// import InputField from "../../../common/htmlComponents/InputField";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import logo from "../../../image/smartbuyerLogo.png";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import { DollarOutlined, TagOutlined } from "@ant-design/icons";
import { ReactComponent as ZipCode } from "../../../image/ZipCode.svg";
import { SuccessNotificationMsg } from "../../../utils/Notifications";
import AddNewClient from "./AddNewClient";
import { authUserData } from "../../../utils/Helper";

const PerformaInvoice = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const navigate = useNavigate();
  const formRef = useRef();
  const { id } = useParams();
  const companyId = authUserData()?.company ? authUserData()?.company : null;
  const performaInvoiceId = id ? atob(id) : null;
  const initialState = {
    invoice_date: moment(new Date()).format("DD-MM-YYYY"),
    due_date: moment(new Date()).format("DD-MM-YYYY"),
    company: "",
    currency: 1,
    subscription: "",
    quantity: 1,
    sell_price: "",
    gst_rate: 18,
    note: null,
    amount: "",
    cgst: null,
    sgst: null,
    total: null,
  };
  const [state, setState] = useState(initialState);
  const [currencyName, setCurrencyName] = useState([]);
  const [packageName, setPackageName] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [company, setCompany] = useState([]);
  const [defaultCompany, setDefaultCompany] = useState([]);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [newlyAddedCompany, setNewlyAddedCompany] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companyAdded, setCompanyAdded] = useState(false);

  useEffect(() => {
    const performaInvoiceGetById = async () => {
      let apiResponse;
      try {
        apiResponse = await getRequest(
          `performa-invoice/${performaInvoiceId}/`
        );

        if (apiResponse.data.success) {
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            invoice_date: moment(
              apiResponse.data.data.invoice_date,
              "DD-MM-YYYY"
            ),
            due_date: moment(apiResponse.data.data.due_date, "DD-MM-YYYY"),
          });

          setState({
            ...apiResponse.data.data,
            invoice_date: moment(
              apiResponse.data.data.invoice_date,
              "DD-MM-YYYY"
            ),
            due_date: moment(apiResponse.data.data.due_date, "DD-MM-YYYY"),
          });
        }
      } catch (error) {
        // ErrorNotificationMsg(t("error_in_list_employee"));
      }
    };
    if (performaInvoiceId !== null) {
      performaInvoiceGetById();
    }
    const getDefaultCompany = async (data) => {
      await getRequest(`company/${companyId}`, data).then((response) => {
        setDefaultCompany(response.data.data);
      });
    };
    getCurrency();
    getSubscriptionPackage();
    // getCompany();
    getDefaultCompany();
  }, [companyId, performaInvoiceId]);

  useEffect(() => {
    const getCompany = async (data) => {
      await getRequest("company/?no_pagination=True", data).then((response) => {
        setCompany(response.data.data);
        if (companyAdded === true) {
          setNewlyAddedCompany([response.data.data[0]]);

          const newlyAddedCompanyData = response.data.data[0];

          setState({
            ...state,
            company: newlyAddedCompanyData.id,
          });
          formRef.current.setFieldsValue({
            company: newlyAddedCompanyData.id,
          });
        }
      });
    };
    getCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyAdded]);
  useEffect(() => {
    const handleGstRateChange = async () => {
      const gstRate = parseFloat(state.gst_rate);

      if (!isNaN(gstRate)) {
        const sellPrice = parseFloat(state.sell_price);
        if (!isNaN(sellPrice)) {
          const gstAmount = (sellPrice * gstRate) / 100;
          const sgst = Math.round(gstAmount / 2);
          const cgst = Math.round(gstAmount / 2);
          const total = Math.round(sellPrice + gstAmount);

          // Update the state with integer values while keeping exact decimal values
          setState({
            ...state,
            gst_rate: gstRate,
            sgst: sgst,
            cgst: cgst,
            total: total,
          });

          // Set the Form.Item values as integers
          formRef.current.setFieldsValue({
            cgst: cgst,
            sgst: sgst,
            total: total,
          });
        } else {
          // Handle the case when sell_price is not a number
          setState({
            ...state,
            gst_rate: gstRate,
            sgst: "",
            cgst: "",
            total: "",
          });

          // Clear the Form.Item values
          formRef.current.setFieldsValue({
            cgst: "",
            sgst: "",
            total: "",
          });
        }
      } else {
        // Clear the values if gst_rate is not a number
        setState({
          ...state,
          gst_rate: "",
          sgst: "",
          cgst: "",
          total: "",
        });

        // Clear the Form.Item values
        formRef.current.setFieldsValue({
          cgst: "",
          sgst: "",
          total: "",
        });
      }
    };
    handleGstRateChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.subscription]);
  const getCurrency = async (data) => {
    await getRequest("currency/?no_pagination=True", data).then((response) => {
      setCurrencyName(response.data.data);
    });
  };
  const getSubscriptionPackage = async (data) => {
    await getRequest("subscription/?no_pagination=True", data).then(
      (response) => {
        setPackageName(response.data.data);
      }
    );
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function numberToWords(number) {
    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const convert = (n, idx) => {
      if (n === 0) return "";
      if (n >= 100) {
        const hundreds = Math.floor(n / 100);
        n = n % 100;
        return `${units[hundreds]} Hundred${n ? " and " : ""}${convert(
          n,
          idx
        )}`;
      }
      if (n >= 11 && n <= 19) return teens[n - 11]; // Fix for numbers in the teens
      if (n === 10 || n >= 20) {
        const unit = n % 10;
        return tens[Math.floor(n / 10)] + (unit ? ` ${units[unit]}` : "");
      }
      return units[n];
    };

    const num = parseInt(number, 10);
    if (isNaN(num)) return "Not a valid number";

    if (num === 0) return "Zero";

    const billion = Math.floor(num / 1e9);
    const million = Math.floor((num % 1e9) / 1e6);
    const thousand = Math.floor((num % 1e6) / 1e3);
    const remainder = num % 1e3;

    const billionWords = convert(billion, 0);
    const millionWords = convert(million, 0);
    const thousandWords = convert(thousand, 0);
    const remainderWords = convert(remainder, 0);

    let result = "";
    if (billionWords) result += `${billionWords} Billion `;
    if (millionWords) result += `${millionWords} Million `;
    if (thousandWords) result += `${thousandWords} Thousand `;

    if (remainderWords) {
      if (thousandWords) {
        result += "and ";
      }
      result += `${remainderWords}`;
    }

    return result.trim();
  }

  const handleSubmit = async () => {
    const payload = {
      invoice_date: moment(state.invoice_date, "DD-MM-YYYY").format(
        "DD-MM-YYYY"
      ),
      due_date: moment(state.due_date, "DD-MM-YYYY").format("DD-MM-YYYY"),
      company: state.company,
      currency: state.currency,
      subscription: state.subscription,
      quantity: state.quantity,
      sell_price: state.sell_price,
      gst_rate: state.gst_rate,
      amount: state.amount,
      note: state.note,
      cgst: state.cgst,
      sgst: state.sgst,
      total: state.total,
    };
    try {
      setBtnLoading(true);

      let apiResponse;
      if (performaInvoiceId === null) {
        apiResponse = await postRequest("performa-invoice/", state);
      } else {
        apiResponse = await patchRequest(
          `performa-invoice/${performaInvoiceId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          performaInvoiceId === null
            ? t("invoice_added_successfully")
            : t("invoice_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        // setBtnLoading(false);
        navigate("/performa-invoice");
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };
  // const handleInputChange = (e) => {
  //   let { name, value } = e.target;
  //   setState({ ...state, [name]: value });
  // };

  const handleDatepickerChange = (date, dateString, fieldName) => {
    setState({ ...state, [fieldName]: dateString ? dateString : null });
  };
  const handleCompanyChange = (name, value) => {
    setState({ ...state, [name]: value });
    const selectedCompany = company.find((item) => item.id === value);
    if (selectedCompany) {
      setCompanyInfo({
        name: selectedCompany.name,
        address: selectedCompany.address_line_1,
        city: selectedCompany.city,
        state: selectedCompany.state,
        pincode: selectedCompany.pincode_number,
        email: selectedCompany.email,
      });
    } else {
      setCompanyInfo(null);
    }
  };
  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
  };
  const handleSubscriptionChange = (name, value) => {
    const selectedPackage = packageName.find((item) => item.id === value);
    if (selectedPackage) {
      setState({
        ...state,
        [name]: value,
        sell_price: selectedPackage.sell_price,
        amount: selectedPackage.sell_price,
        // gst_rate: "",
        // sgst: "",
        // cgst: "",
        // total: "",
      });

      // formRef.current.setFieldsValue({
      //   gst_rate: "",
      //   cgst: "",
      //   sgst: "",
      //   total: "",
      // });
    } else {
      setState({ ...state, [name]: value, sell_price: null, amount: null });
    }
    formRef.current.setFieldsValue({ sell_price: selectedPackage.sell_price });
    formRef.current.setFieldsValue({ amount: selectedPackage.sell_price });
  };

  return (
    <>
      <div className="ListingTopBar">
      <div className="pagenamewrap">
        <div className="pagename">
          <h3>{t("addInvoice")}</h3>
          
          <Breadcrumb className="Breadcrumb-Sec">
          <Breadcrumb.Item>
            <Link to="/dashboard">{t("home")}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/performa-invoice"> {t("performaInvoiceList")}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{t("addInvoice")}</Breadcrumb.Item>
        </Breadcrumb>
          </div>
         
      </div>
        
      </div>
      <section className="grid-sec FormSection Container InvoiceSec">
        <div className="FormHeader">
          <h1>Performa Invoice</h1>
        </div>
        <div className="FormBody ">
          <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
            <Row>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                className="InvoiceSec_Logo_Responsive"
              >
                <img
                  className=""
                  src={logo}
                  width={"200px"}
                  height={"36px"}
                  alt="Smart Buyer Logo"
                ></img>
              </Col>

              <Col
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                className="InvoiceSec_Personale_details"
              >
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="invoice_number"
                    label={t("label_invoice_number")}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: <Trans>{t("val_invoice_number")}</Trans>,
                    //   },
                    // ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_invoice_number")}
                      readOnly
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="invoice_date"
                    label="Invoice Date"
                    initialValue={moment(state.invoice_date, "DD-MM-YYYY")}
                  >
                    <DatePicker
                      showTime
                      format="DD-MM-YYYY"
                      onChange={(date, dateString) =>
                        handleDatepickerChange(date, dateString, "invoice_date")
                      }
                      value={
                        state.invoice_date
                          ? moment(state.invoice_date, "DD-MM-YYYY")
                          : moment(new Date(), "DD-MM-YYYY")
                      }
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="due_date"
                    label="Due Date"
                    initialValue={moment(state.due_date, "DD-MM-YYYY")}
                  >
                    <DatePicker
                      showTime
                      format="DD-MM-YYYY"
                      onChange={(date, dateString) =>
                        handleDatepickerChange(date, dateString, "due_date")
                      }
                      value={
                        state.due_date
                          ? moment(state.due_date, "DD-MM-YYYY")
                          : moment(new Date(), "DD-MM-YYYY")
                      }
                    />
                  </Form.Item>
                </Col>
              </Col>

              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                className="InvoiceSec_Logo"
              >
                <img
                  className=""
                  src={logo}
                  width={"200px"}
                  height={"36px"}
                  alt="Smart Buyer Logo"
                ></img>
              </Col>
            </Row>

            <div className="InvoiceAddressSec">
              <Row gutter={16}>
                <Col
                  className="RFQAddressBox"
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  span={8}
                >
                  <Card>
                    <Col className="TextFeild gutter-row">
                      <Form.Item
                        name="billedby"
                        label={t("pl_billed_by")}
                        initialValue={defaultCompany.id}
                        // prefix={<ZipCode />}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_enter_address")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          // showArrow
                          // value={state.billed_by}
                          // placeholder={t("pl_select_currency")}
                          suffixIcon={null}
                          defaultValue={1}
                          onChange={(value) =>
                            handleSelectChange("billed_by", value)
                          }
                        >
                          <Option
                            key={defaultCompany.id}
                            value={defaultCompany.id}
                          >
                            {defaultCompany.name}
                          </Option>
                        </Select>
                      </Form.Item>
                      <div className="getAddress">
                        <ul>
                          <li>
                            <b>{t("Business Name")}</b>
                            <span>
                              {defaultCompany ? defaultCompany.name : ""}
                            </span>
                          </li>
                          <li>
                            <b>{t("Address")}</b>
                            <span>
                              {defaultCompany
                                ? defaultCompany.address_line_1
                                : ""}
                            </span>
                          </li>

                          <li>
                            <b>{t("City & State")}</b>
                            <span>
                              {defaultCompany ? defaultCompany.city : ""}{" "}
                            </span>
                            <span>
                              {defaultCompany ? defaultCompany.state : ""}
                            </span>
                          </li>

                          <li>
                            <b>{t("Pincode")}</b>
                            <span>
                              {defaultCompany
                                ? defaultCompany.pincode_number
                                : ""}
                            </span>
                          </li>
                          <li>
                            <b>{t("Email")}</b>
                            <span>
                              {defaultCompany ? defaultCompany.email : ""}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Card>
                </Col>

                <Col
                  className="RFQAddressBox"
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  span={8}
                >
                  <Card>
                    <Col className="TextFeild gutter-row">
                      <Form.Item
                        name="company"
                        label={t("pl_billed_to")}
                        // prefix={<ZipCode />}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_enter_address")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          showSearch
                          placeholder={t("pl_select_client")}
                          optionFilterProp="children"
                          onChange={(value) =>
                            handleCompanyChange("company", value)
                          }
                        >
                          {company.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      {performaInvoiceId !== null ||
                      companyInfo ||
                      companyAdded ? (
                        <div className="getAddress">
                          <ul>
                            <li>
                              <b>{t("Business Name")}</b>
                              {companyInfo ? (
                                <span>{companyInfo.name}</span>
                              ) : companyAdded &&
                                newlyAddedCompany &&
                                newlyAddedCompany[0] ? (
                                <span>{newlyAddedCompany[0].name}</span>
                              ) : (
                                <span>{state.business_name}</span>
                              )}

                              {/* <span>{businessName}</span> */}
                            </li>
                            <li>
                              <b>{t("Address")}</b>
                              {companyInfo ? (
                                <span>{companyInfo.address}</span>
                              ) : companyAdded &&
                                newlyAddedCompany &&
                                newlyAddedCompany[0] ? (
                                <span>
                                  {newlyAddedCompany[0].address_line_1}
                                </span>
                              ) : (
                                <span>{state.address}</span>
                              )}
                              {/* {companyInfo ? (
                                <span>{companyInfo.address}</span>
                              ) 
                              : (
                                <span>{state.address}</span>
                              )} */}
                            </li>

                            <li>
                              <b>{t("City & State")}</b>
                              {companyInfo ? (
                                <span>{companyInfo.city}</span>
                              ) : companyAdded &&
                                newlyAddedCompany &&
                                newlyAddedCompany[0] ? (
                                <span>{newlyAddedCompany[0].city}</span>
                              ) : (
                                <span>{state.city}</span>
                              )}{" "}
                              {companyInfo ? (
                                <span>{companyInfo.state}</span>
                              ) : companyAdded &&
                                newlyAddedCompany &&
                                newlyAddedCompany[0] ? (
                                <span>{newlyAddedCompany[0].state}</span>
                              ) : (
                                <span>{state.state}</span>
                              )}
                            </li>
                            <li>
                              <b>{t("Pincode")}</b>

                              {companyInfo ? (
                                <span>{companyInfo.pincode}</span>
                              ) : companyAdded &&
                                newlyAddedCompany &&
                                newlyAddedCompany[0] ? (
                                <span>
                                  {newlyAddedCompany[0].pincode_number}
                                </span>
                              ) : (
                                <span>{state.pincode_number}</span>
                              )}
                            </li>
                            <li>
                              <b>{t("Email")}</b>

                              {companyInfo ? (
                                <span>{companyInfo.email}</span>
                              ) : companyAdded &&
                                newlyAddedCompany &&
                                newlyAddedCompany[0] ? (
                                <span>{newlyAddedCompany[0].email}</span>
                              ) : (
                                <span>{state.email}</span>
                              )}
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <div className="getAddress BillTOAddress">
                          Select a Client/Business from list
                          <span className="ORSec">Or</span>
                          <Button
                            className="BlueShadowBtn"
                            type="primary"
                            onClick={showModal}
                            icon={
                              <img src={PlusSquareOutlined} alt="Plus Square" />
                            }

                            // icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                          >
                            Add New Client
                          </Button>
                          <Modal
                            className="ModelPopupSec"
                            title="Add Client"
                            open={isModalOpen}
                            onOk={handleOk}
                            onCancel={handleCancel}
                            closable={false}
                            wrapClassName="modal-wrapper"
                          >
                            <AddNewClient
                              handleCancel={handleCancel}
                              setCompanyAdded={setCompanyAdded}
                            />
                          </Modal>
                        </div>
                      )}
                    </Col>
                  </Card>
                </Col>
              </Row>
            </div>

            <Row className="Currencyrow custrow">
              <Col className="TextFeild gutter-row">
                <Form.Item
                  name="currency"
                  label={t("pl_currency")}
                  prefix={<ZipCode />}
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select Currency</Trans>,
                    },
                  ]}
                  initialValue={state.currency}
                >
                  <Select
                    showArrow
                    placeholder={t("pl_select_currency")}
                    onChange={(value) => handleSelectChange("currency", value)}
                    defaultValue={1}
                    optionFilterProp="children"
                  >
                    {currencyName.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.currency_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Col className="InvoiceTable">
              <ul>
                <li className="TableFeild">
                  <h4>Subscription Package</h4>

                  <Form.Item
                    name="subscription"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_subscription_package")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_subscription_package")}
                      onChange={(value) =>
                        handleSubscriptionChange("subscription", value)
                      }
                    >
                      {packageName.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.package_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </li>

                <li className="TableFeild">
                  <h4>GST</h4>

                  <Form.Item
                    name="gst_rate"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_gst_number")}</Trans>,
                      },
                    ]}
                    initialValue={state.gst_rate}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_enter_gst_number")}
                      value={state.gst_rate}
                      // onChange={(e) =>
                      //   handleGstRateChange(
                      //     parseInt(e.target.value, 10) || null
                      //   )
                      // }
                      readOnly
                    />
                  </Form.Item>
                </li>

                <li className="TableFeild">
                  <h4>Rate</h4>

                  <Form.Item
                    name="sell_price"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_rate")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_rate")}
                      // value={`1`} // Set the value from the state
                      // defaultValue={state.sell_price}
                      // value={1}
                      value={state.sell_price}
                      readOnly
                      onChange={(e) =>
                        handleChange(
                          "sell_price",
                          parseInt(e.target.value, 10) || null
                        )
                      }
                    />
                  </Form.Item>
                </li>

                <li className="TableFeild">
                  <h4>Amount</h4>

                  <Form.Item
                    name="amount"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_amount")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_enter_amount")}
                      value={state.amount}
                      onChange={(e) =>
                        handleChange(
                          "amount",
                          parseInt(e.target.value, 10) || null
                        )
                      }
                      readOnly
                    />
                  </Form.Item>
                </li>
                <li className="TableFeild">
                  <h4>CGST</h4>

                  <Form.Item
                    name="cgst"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_amount")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_enter_amount")}
                      value={state.cgst}
                      onChange={(e) =>
                        handleChange(
                          "cgst",
                          parseInt(e.target.value, 10) || null
                        )
                      }
                      readOnly
                    />
                  </Form.Item>
                </li>
                <li className="TableFeild">
                  <h4>SGST</h4>

                  <Form.Item
                    name="sgst"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_amount")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_enter_amount")}
                      value={state.sgst}
                      onChange={(e) =>
                        handleChange(
                          "sgst",
                          parseInt(e.target.value, 10) || null
                        )
                      }
                      readOnly
                    />
                  </Form.Item>
                </li>
                <li className="TableFeild">
                  <h4>Total</h4>

                  <Form.Item
                    name="total"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_amount")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_enter_amount")}
                      value={state.total}
                      onChange={(e) =>
                        handleChange(
                          "total",
                          parseInt(e.target.value, 10) || null
                        )
                      }
                      readOnly
                    />
                  </Form.Item>
                </li>
              </ul>
            </Col>

            <div className="InvoiceTotalSec">
              <Row>
                <Col
                  xs={24}
                  sm={24}
                  md={16}
                  lg={16}
                  xl={16}
                  className="InvoiceNote"
                >
                  <Form.Item
                    name="note"
                    label={t("pl_note")}
                    rules={[
                      {
                        // required: true,
                        message: <Trans>{t("val_note")}</Trans>,
                      },
                    ]}
                  >
                    <TextArea
                      rows={4}
                      onChange={(e) => handleChange("note", e.target.value)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8} lg={8} xl={8} className="GSTSEC">
                  <div className="GSTli">
                    <span>
                      <TagOutlined className="TagOutlinedIcon" />
                      SGST 9% 1.00
                    </span>
                    <span>{state.sgst}</span>
                  </div>
                  <div className="GSTli">
                    <span>
                      <TagOutlined className="TagOutlinedIcon" />
                      CGST 9% 1.00
                    </span>
                    <span>{state.cgst}</span>
                  </div>
                  {/* <div className="InvoiceTotaleAmt">
                    <span>Total (INR)</span>
                    <span>{state.total}</span>
                  </div>
                  <div className="GSTli">
                    <span>
                      <DollarOutlined className="DollarOutlinedIcon" />

                      {state.total && numberToWords(state.total)}
                    </span>
                  </div> */}
                  <div className="InvoiceTotaleAmt">
                    <span>Total (INR)</span>
                    <span>{state.total !== null ? state.total : 0}</span>
                  </div>
                  <div className="GSTli">
                    <span>
                      <DollarOutlined className="DollarOutlinedIcon" />
                      {state.total !== null && !isNaN(state.total)
                        ? numberToWords(state.total)
                        : "Invalid Total Value"}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="FormFooter">
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="button"
                label={t("save_as_draft")}
                // onClick={() => navigate("/employee")}
              />
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label={t("send")}
                loading={btnLoading}
              />
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};

export default PerformaInvoice;
